import type { FormField } from '@cli-types/core-engine/schema.js'
import {
  ADD_FIELD_CONFIRM_INITIAL_VALUE,
  CREATE_PROMPT_CONTEXT
} from '@cli-constants/prompt-copy.js'
import { promptConfirm } from '../schema-prompts/prompt-confirm.js'
import { promptFormField } from './prompt-form-field.js'

export async function promptAdditionalFormFields(
  schemasDir: string,
  fields: FormField[],
  message = 'Add another field?'
): Promise<void> {
  while (await promptConfirm(CREATE_PROMPT_CONTEXT, message, ADD_FIELD_CONFIRM_INITIAL_VALUE)) {
    await promptFormField(schemasDir, fields)
  }
}
